__turbopack_context__.v({
  "leftIcon": "link-button-module-scss-module__rGD-sG__leftIcon",
  "linkButton": "link-button-module-scss-module__rGD-sG__linkButton",
  "rightIcon": "link-button-module-scss-module__rGD-sG__rightIcon",
});
